import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("./../layouts/layoutDefault"),
    children: [
      {
        path: "/",
        name: "consulta",
        component: () => import("@/views/consulta/consulta.vue"),
      },
      {
        path: "simulacao",
        name: "simulacao",
        component: () => import("@/views/simulacao/simulacao.vue"),
        props: true,
      },
      {
        path: "prorrogacao/parcelas/amz",
        name: "prorrogar-parcelas-amz",
        component: () => import("@/views/prorrogacao/parcelasAmz.vue"),
        props: true,
      },
      {
        path: "aditivo",
        name: "aditivo",
        component: () => import("@/views/aditivo/aditivo.vue"),
        props: true,
      },
      {
        path: "proposta-recusada",
        name: "propostaRecusada",
        component: () => import("@/views/propostaRecusada.vue"),
      },
      {
        path: "aditivo-sucesso",
        name: "aditivoSucesso",
        component: () => import("@/views/aditivoSucesso.vue"),
        props: true,
      },
      {
        path: "proposta-amz-sucesso",
        name: "propostaAmzSucesso",
        component: () => import("@/views/propostaAmzSucesso.vue"),
        props: true,
      },
      {
        path: "comprovacao-rural",
        name: "comprovacaoRural",
        component: () => import("@/views/comprovacao/envio-arquivos-rural.vue"),
        props: true,
      },
      {
        path: "comprovacao-nao-rural",
        name: "comprovacaoNaoRural",
        component: () =>
          import("@/views/comprovacao/envio-arquivos-nao-rural.vue"),
        props: true,
      },
    ],
  },
];

export default routes;
